import { createRootRoute, Outlet } from '@tanstack/react-router';

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <header
        className="sticky top-0 z-50 border-b"
        style={{
          background: 'rgba(10,12,16,.86)',
          borderColor: 'rgba(255,255,255,.10)',
          backdropFilter: 'blur(10px)',
        }}
      >
        <div className="max-w-[1200px] mx-auto px-4 py-3 flex items-center gap-4 flex-wrap">
          <div className="flex items-center gap-3 min-w-[220px]">
            <div
              className="w-11 h-11 rounded-[10px] grid place-items-center font-black text-white"
              style={{ background: '#2f7bff' }}
            >
              AHF
            </div>
            <div className="leading-tight">
              <b className="block text-[18px] text-white">AIHitFactory</b>
              <span className="block text-[12px] text-white/75">Radio, Video, On demand</span>
            </div>
          </div>

          <nav className="flex items-center gap-3 flex-wrap text-[13px] font-extrabold text-white">
            <a href="https://www.aihitfactory.com/" className="opacity-90 hover:opacity-100 no-underline">HOME</a><span>|</span>

            <a href="#" onClick={(e) => { 
		e.preventDefault();
                window.open('http://radio.aihitfactory.com', 'radio', 'width=420,height=220');
              }}
              className="opacity-90 hover:opacity-100 no-underline" >
              RADIO
            </a><span>|</span>
           
            <a href="#/settings" className="opacity-90 hover:opacity-100 no-underline">SETTINGS</a>
            <span>|</span>
            <a href="https://mastering.fenixstudio.org/" target="_blank" rel="noopener">AUDIO MASTERING TOOL</a><span>|</span>
            <a href="https://fenixstudio.org/contact-form/" target="_blank" rel="noopener noreferrer" className="opacity-90 hover:opacity-100 no-underline"> CONTACT</a>
          </nav>
        </div>
      </header>



      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="border-t border-border px-4 py-4 text-center text-sm text-muted-foreground">
        <a
          href="https://www.buymeacoffee.com/aihitfactory"
          target="_blank"
          rel="noopener noreferrer"
          className="no-underline font-bold"
          style={{ color: '#FFDD00', fontFamily: 'cursive' }}
        >
          🍕 Buy me a pizza
        </a>{' '}
        | AIHitFactory, created by{' '}
        <a
          href="https://fenixstudio.org"
          target="_blank"
          rel="noopener noreferrer"
          className="no-underline"
          style={{ color: '#9fc5ff', borderBottom: '1px dotted #2b67a1' }}
        >
          Fenix Studio
        </a>
      </footer>
    </div>
  );
}